const routeDefault = '/';

export default routeDefault
